import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { Linking, Pressable, ScrollView, View } from "react-native"
import {
  Body,
  H2,
  H5,
  H6,
  Small,
  TealText,
  Tiny,
} from "@/components/standard/BFText"

import {
  AltitudeProductCard,
  DoubleDoubleProductCard,
  ReFiProductCard,
  StandardProductCard,
  ZeroGravityProductCard,
} from "@/screens/prequal/components/LoanProductCard"

import { BFLogoScreen } from "@/components/standard/screen/BFLogoScreen"
import { useUserQualifiedForContactLink } from "@/hooks/useUserQualifiedForContactLink"
import Headset from "phosphor-react-native/src/icons/Headset"
import { router } from "expo-router"
import { loanProductsQuestionClicked } from "@/analytics/events/loans"
import { loanSearchPath } from "@/screens/loans/utils/LoanUtils"

export const ProductsScreen = () => {
  const qualifiedForContactLink = useUserQualifiedForContactLink()
  return (
    <BFLogoScreen>
      <Vertical className={"justify-between flex-1"}>
        <Vertical className={"gap-5 mt-10"}>
          <Vertical>
            <H2 color={"white"}>
              We’d <TealText>love</TealText> to work with you!
            </H2>
            <Body color={"white"}>
              Based on the information provided, here’s a look at the loan
              options that may be available to you for your next deal*:
            </Body>
          </Vertical>
          <ScrollView
            horizontal={true}
            contentContainerClassName={"gap-5 flex-row"}
            className={"max-h-[180px]"}
          >
            <StandardProductCard />
            <AltitudeProductCard />
            <ZeroGravityProductCard />
            <DoubleDoubleProductCard />
            <ReFiProductCard />
          </ScrollView>
          <Tiny color={"white"}>
            *Eligibility is based on self-reported information provided. Final
            verification of qualifications will be required.
          </Tiny>
        </Vertical>
        <Vertical>
          <Pressable
            testID={"apply-now"}
            className={"justify-center items-center "}
            onPress={() => {
              router.push(loanSearchPath())
            }}
          >
            <Vertical className={"mx-5 items-center"}>
              <H5 color={"white"}>Ready to move forward?</H5>
              <Small color={"white"} className={"text-center"}>
                {" "}
                Provide your property’s info to view your personalized term
                sheet estimates.
              </Small>
              <Small color={"teal"} className={"underline"}>
                Apply Now
              </Small>
            </Vertical>
          </Pressable>
        </Vertical>
        <Vertical>
          {qualifiedForContactLink && (
            <Pressable
              testID={"contact-us"}
              onPress={() => {
                loanProductsQuestionClicked("Loan Property Search")
                void Linking.openURL("https://backflip.app.link/e/WBWTyZcnSLb")
              }}
            >
              <Horizontal className={"bg-midnight-blue p-3 gap-3 rounded-lg"}>
                <View className={"justify-center items-center"}>
                  <Headset size={20} color={"white"} />
                </View>

                <Vertical>
                  <H5 color={"white"}>Questions? We’re here to help</H5>
                  <H6 color={"teal"} className={"underline"}>
                    Speak with a lending expert ›{" "}
                  </H6>
                </Vertical>
              </Horizontal>
            </Pressable>
          )}
        </Vertical>
      </Vertical>
    </BFLogoScreen>
  )
}
